import { useEffect, useRef, useState, useContext } from 'react'
import { useForm } from 'react-hook-form'
import Skeleton from 'react-loading-skeleton'
import PrimaryButton from '../primaryButton'
import CameraView from './CameraView'
import Card from '../Card'
import TextButton from '../textButton'
import { UserContext } from '../../contexts/user'
import {
  CamaraIcon,
  GreenCheckIcon,
  LoadingIcon,
  ClipIcon,
  ErrorIcon
} from './assets'

const UploadMediaFile = ({
  image,
  title,
  textBlue,
  detail,
  endPointFile,
  extraInputs,
  callBack,
  sendFile,
  inputsRequired
}) => {
  const [view, setView] = useState('startView')
  const [imgSrc, setImgSrc] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingFile, setIsLoadingFile] = useState(true)
  const [isLoadingImg, setIsLoadingImg] = useState(true)

  const { handleSubmit, watch, control } = useForm()
  const inputFile = useRef(null)
  const [docSrc, setDocSrc] = useState('')
  const [type, setType] = useState(null)
  const [showCallBackButton, setShowCallBackButton] = useState(false)
  const [idImg, setIdImg] = useState(null)
  const [statusFile, setStatusFile] = useState('')
  const { refreshUserToken } = useContext(UserContext)

  const onSubmit = (data) => {
    callBack(data).then(() => {})
  }

  function recortarNombreDocumento(string) {
    let res = string.substring(string.lastIndexOf('\\') + 1)
    if (res.length > 24) {
      res = `${res.substring(0, 15)}...${res.substring(res.length - 6)}`
    }
    return res
  }

  async function submitFile() {
    // @ts-ignore
    setIsLoadingFile(true)
    setIsLoadingImg(true)

    const file = document.querySelector('#file').files[0]

    if (file && file != '') {
      const formData = new FormData()
      formData.append('avatar', file)
      sendFile(formData)
        .then((data) => {
          if (data.error) {
            setStatusFile(<ErrorIcon />)
          } else {
            setIsLoadingImg(true)
            setIdImg(data)
            setStatusFile(<GreenCheckIcon />)
            refreshUserToken()
          }
          setIsLoadingFile(false)
        })
        .catch((error) => {
          setStatusFile(<ErrorIcon />)
        })
        .finally(() => {
          setIsLoadingFile(false)
          setIsLoadingImg(false)
        })
    }
  }

  useEffect(() => {
    if (imgSrc) {
      fetch(imgSrc)
        .then((res) => res.blob())
        .then((blob) => {
          const formData = new FormData()
          const contentType = imgSrc.split(';')[0].split(':')[1]
          const file = new File([blob], 'avatar.jpeg', { type: contentType })
          formData.append('avatar', file)
          sendFile(formData)
            .then((data) => {
              if (data.error) {
                setStatusFile(<ErrorIcon />)
              } else {
                setIsLoadingImg(true)
                setIdImg(data)
                refreshUserToken()
                setStatusFile(<GreenCheckIcon />)
              }
            })
            .catch((error) => {
              setStatusFile(<ErrorIcon />)
            })
            .finally(() => setIsLoadingFile(false))
        })
    }
  }, [imgSrc])

  useEffect(() => {
    if (view === 'finishView') {
      if (type === 'file') inputFile.current.click()
    }
  }, [view])

  useEffect(() => {
    idImg ? setShowCallBackButton(true) : setShowCallBackButton(false)
  }, [idImg])

  useEffect(() => {
    const dataInput = watch((value) => {
      if (inputsRequired) {
        const isFalse = inputsRequired.find(
          (element) =>
            value[element] === '' || typeof value[element] === 'undefined'
        )
        setShowCallBackButton(!isFalse)
      }
    })
    return () => dataInput.unsubscribe()
  }, [watch])

  const views = {
    startView: (
      <div className='flex flex-col text-center h-full gap-3'>
        {typeof image === 'string' ? (
          ''
        ) : (
          <div className='self-center flex mt-3 rounded-full h-36 w-36'>
            <img className='rounded-full' src={image} alt='User avatar' />
          </div>
        )}
        {/* {image} */}
        <p className='text-base text-black mb-3 font-bold'>{title}</p>
        <div className='flex flex-col gap-2 justify-center items-center shadow-pagorealizado bg-white md:px-0 w-full'>
          <PrimaryButton
            buttonText={
              <div className='flex p-3 relative w-full'>
                <CamaraIcon
                  className='absolute -left-20 h-6 w-6'
                  color='white'
                />
                <span className='flex-grow'>Tomar Foto</span>
              </div>
            }
            primaryButtonFunction={() => {
              setView('cameraView')
            }}
          />
          <PrimaryButton
            buttonText='Buscar en Galería'
            primaryButtonFunction={() => {
              setType('file')
              setView('finishView')
            }}
            outlined
          />
        </div>
      </div>
    ),
    cameraView: (
      <div className='top-0 w-full bg-white flex flex-col items-center justify-start h-full'>
        <CameraView setImgSrc={setImgSrc} setView={setView} detail={detail} />
      </div>
    ),
    finishView: (
      <div className='flex flex-col items-center text-center h-full'>
        <p className='text-xs text-blue-900 font-bold my-2'>{textBlue}</p>
        <div className='w-full mb-6 flex-grow'>
          {imgSrc ? (
            <Card className='flex items-center p-3 h-18 w-full bg-white'>
              <div className='flex items-center justify-center bg-black w-[68px] h-14 rounded-[3px] p-0.5'>
                <img
                  src={imgSrc}
                  alt='...'
                  className='rounded-lg h-full w-full object-contain'
                />
              </div>
              <div className='flex-grow px-4 text-left'>
                <TextButton
                  className='p-0'
                  handleFunction={() => {
                    setIsLoadingFile(true)
                    setView('cameraView')
                  }}
                >
                  Sacar otra foto
                </TextButton>
              </div>
              <div>{isLoadingFile ? <LoadingIcon /> : statusFile}</div>
            </Card>
          ) : (
            <>
              <input
                type='file'
                id='file'
                ref={inputFile}
                onChange={() => {
                  inputFile.current.value === '' && setIdImg(null)
                  setDocSrc(inputFile.current.value)
                  submitFile()
                }}
                accept='image/png, image/jpeg'
                className='hidden'
              />
              <Card
                className='flex items-center p-3 h-18 w-full bg-white'
                // action={() => {
                //   inputFile.current.click()
                // }}
              >
                <div className='flex items-center justify-center bg-blue-100 cursor-pointer rounded-full w-14 h-14 '>
                  {isLoadingFile ? (
                    <>
                      {isLoadingImg ? (
                        <Skeleton circle width={58} height={59} />
                      ) : (
                        <ClipIcon />
                      )}
                    </>
                  ) : (
                    <img
                      className='rounded-full bg-center object-cover bg-cover w-14 h-15'
                      src={image}
                      alt='New profile avatar'
                    />
                  )}
                </div>
                <div className='flex-grow px-4 text-left'>
                  <p className='text-base font-medium pl-1'>
                    {recortarNombreDocumento(docSrc)}
                  </p>
                  <TextButton
                    className='p-0'
                    hasIcon={false}
                    handleFunction={() => {
                      inputFile.current.click()
                    }}
                  >
                    Elegir{' '}
                    {inputFile.current && inputFile.current.value
                      ? 'otro'
                      : 'un'}{' '}
                    documento
                  </TextButton>
                </div>
                <div>
                  {/* {docSrc != '' && */}
                  {isLoadingFile ? <LoadingIcon /> : statusFile}
                </div>
              </Card>
            </>
          )}
        </div>
        <form className='w-full ' onSubmit={handleSubmit(onSubmit)}>
          {extraInputs && <div>extraInputs(control)</div>}

          {showCallBackButton && (
            <PrimaryButton
              type='submit'
              buttonText='Finalizar'
              primaryButtonFunction={() => {
                callBack()
              }}
              isLoading={isLoading}
              isDisabled={false}
              margins=''
            />
          )}
        </form>
        {/* <div className='bottom-0 p-6 w-full '></div> */}
      </div>
    )
  }

  return <div className='h-full'>{views[view]}</div>
}

export default UploadMediaFile
